import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import links from "./data";
import NewHeader from "../../../Layouts/NewHeader";
import NewFooter from "../../../Layouts/NewFooter";

const PricingDetails = () => {
  return (
    <>
     <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <NewHeader/>
    <div className="container" style={{flex: 1, paddingTop: "20px"}}>
      <div
        style={{
          fontSize: "18px",
          paddingTop: "10px",
        }}
        className="card px-5 py-5 my-3 m-auto shadow-lg mt-2"
      >
        <div>
          <h2 className="mt-4" style={{color: "#212529", fontSize: "32px"}}>Pricing Details</h2>
          <p className="fs-16">
            All payments will be 100% converted into Electricity recharge
            credits.
          </p>
        </div>
        
        </div>
      </div>
      <NewFooter />
      </div>
    </>
  );
};

export default PricingDetails;
